module.exports = __webpack_public_path__ + "src/assets/img/acum.669aed97.svg";